module.exports = __webpack_public_path__ + "static/media/line.b2c86459.svg";